import { triggerTracrTrack } from '@/utils/tracr'

const getStoredEvents = () => {
  const serializedEvents = localStorage.getItem('rvexp.events')

  return serializedEvents ? JSON.parse(serializedEvents) : {}
}

const storeEvent = (event, experimentCode) => {
  const events = getStoredEvents()
  const experimentEvents = events[experimentCode] ?? []

  if (experimentEvents.includes(event)) return

  experimentEvents.push(event)
  events[experimentCode] = experimentEvents

  localStorage.setItem('rvexp.events', JSON.stringify(events))
}

const getEventsForExperiment = (experimentId) => {
  const events = getStoredEvents()
  return events[experimentId] ?? []
}

const didTrackEvent = (eventType, experimentId) => {
  const events = getEventsForExperiment(experimentId)
  return events.includes(eventType)
}

export const trackEvent = (eventType, experimentId, customData) => {
  if (didTrackEvent(eventType, experimentId)) return

  triggerTracking(customData)
}

const triggerTracking = (customData) => {
  const verifyTrackingSetup = setInterval(() => {
    clearInterval(verifyTrackingSetup)

    triggerTracrTrack('redTesting', customData)

    const { type, experiment } = customData
    storeEvent(type, experiment)
  }, 150)
}
